import { createFileRoute, Outlet } from "@tanstack/react-router";
import { redirectUnlessCapability } from "@/lib/organization-capabilities";

export const Route = createFileRoute("/funding")({
  beforeLoad: ({ context: { queryClient } }) =>
    redirectUnlessCapability(queryClient, "canViewFunding"),
  component: () => <Outlet />,
});
